export default "__VITE_ASSET__009214ca__"